/**
 * 大屏模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  // 获取表单和表单字段
  {
    name: 'getFormList',
    url: '/api/back-end-api/v1/sync-form/list',
  },
  {
    name: 'getFormData',
    url: '/api/back-end-api/v1/sync-form/page',
    method: 'POST',
  },
];
